<div edsRow>
  <div edsCol>
    <eds-section-title
      theme="basic"
      [preTitle]="content?.preTitle"
      [title]="content?.title"
    ></eds-section-title>
  </div>
</div>
